module.exports = __webpack_public_path__ + "UniversityOfMissouri_white400x75-eb9af7d56c271b077e3c3abba80ee9d5.png";